module.exports = __webpack_public_path__ + "img/s1-coffee.38ad20bc.png";